import BackgroundImage from 'gatsby-background-image'
import React from 'react'
import Content from './Content'
import './style.scss'
const BasicBlock = ({ basicBlock }) => {
    if (!basicBlock) {
        return null
    }

    const {
        background: {
            backgroundType,
            gradientColor,
            imageBackground,
            solidColor
        }
    } = basicBlock
    const bgImage = imageBackground?.image?.localFile?.childImageSharp?.fluid
    const bgGradient = `linear-gradient(to right,${gradientColor?.firstColor},${gradientColor?.secondColor})`
    const imagePos = {
        Right: 'right-bg',
        'Full Left': 'bg-full-left',
        'Full Right': 'bg-full-right',
        Full: 'full'
    }
    const style = {
        backgroundImage:
            backgroundType === 'Image' && imageBackground.position !== 'Full'
                ? `url(${imageBackground?.image?.sourceUrl})`
                : bgGradient,
        backgroundColor: solidColor && solidColor
    }
    if (bgImage)
        return (
            <BackgroundImage
                Tag={`div`}
                style={{
                    backgroundImage: bgGradient,
                    backgroundColor: solidColor && solidColor
                }}
                fluid={bgImage}
                id={imagePos[imageBackground.position]}
                className={`basic-block`}
            >
                <Content basicBlock={basicBlock} />
            </BackgroundImage>
        )
    else {
        return (
            <div
                style={style}
                id={imagePos[imageBackground.position]}
                className={`basic-block`}
            >
                <Content basicBlock={basicBlock} />
            </div>
        )
    }
}

export default BasicBlock
